/**
 * @generated SignedSource<<b0a8342d9fdd521c7874e63ec6e8e6c4>>
 * @relayHash fffb275f3c1642370db8ca26640d4d1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c62d9f35893c4558aa832a3da78fb1119e9bb8ef77a3c044ed4fd5a3679820f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiMoveIssuesBetweenVersionsQuery$variables = {
  first: number;
  projectAri: string;
  versionAri: string;
};
export type uiMoveIssuesBetweenVersionsQuery$data = {
  readonly jira: {
    readonly version: {
      readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionPicker_VersionPicker_jiraVersion" | "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion">;
    };
    readonly versionsForProject: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges">;
      } | null | undefined>;
    };
  };
};
export type uiMoveIssuesBetweenVersionsQuery = {
  response: uiMoveIssuesBetweenVersionsQuery$data;
  variables: uiMoveIssuesBetweenVersionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionAri"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionAri"
  }
],
v4 = {
  "kind": "Literal",
  "name": "filter",
  "value": [
    "UNRELEASED"
  ]
},
v5 = {
  "kind": "Variable",
  "name": "jiraProjectId",
  "variableName": "projectAri"
},
v6 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v11 = [
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiMoveIssuesBetweenVersionsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraVersion"
                      }
                    ],
                    "type": "JiraVersion"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.version"
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": "versionsForProject",
                "args": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "__moveIssuesBetweenVersions_versionsForProject_connection",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraVersionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges"
                        },
                        (v6/*: any*/),
                        {
                          "concreteType": "JiraVersion",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v7/*: any*/)
                          ]
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.versionsForProject.edges"
                  },
                  (v8/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.versionsForProject"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiMoveIssuesBetweenVersionsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "canAddAndRemoveIssues"
                  },
                  {
                    "concreteType": "JiraVersionWarningConfig",
                    "kind": "LinkedField",
                    "name": "warningConfig",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "openReview"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "projectId"
                      },
                      (v9/*: any*/)
                    ]
                  }
                ],
                "type": "JiraVersion"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": (v11/*: any*/),
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "versionsForProject",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v9/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v7/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              },
              (v8/*: any*/)
            ]
          },
          {
            "args": (v11/*: any*/),
            "filters": [
              "jiraProjectId",
              "filter"
            ],
            "handle": "connection",
            "key": "moveIssuesBetweenVersions_versionsForProject",
            "kind": "LinkedHandle",
            "name": "versionsForProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0c62d9f35893c4558aa832a3da78fb1119e9bb8ef77a3c044ed4fd5a3679820f",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "versionsForProject"
          ]
        }
      ]
    },
    "name": "uiMoveIssuesBetweenVersionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "58c061e61158c45d3f183de8ea9ac7ab";

export default node;
